<template>
  <div class="meal" :class="{ 'energy-distribution': energyDistribution }">
    <div class="meal-hour">
      <BaseSelect
        class="meal-hour__select"
        :options="hourOptions"
        :model-value="meal.hour"
        @update:model-value="dietStore.updateMealHour(index, $event)"
      />
    </div>
    <div class="meal-name">
      <BaseInput
        :test-id="`DietDetailAssumptions__${index}__${meal.name}`"
        class="meal-name__input"
        :model-value="meal.name"
        maxlength="50"
        @update:model-value="dietStore.updateMealName(index, $event)"
      />
    </div>
    <div class="meal-type">
      <BaseSelect
        class="meal-type__select"
        :options="mealTypes"
        :model-value="meal.type"
        @update:model-value="dietStore.updateMealType(index, $event)"
      />
    </div>
    <div v-if="energyDistribution" class="meal-energy-distrubution">
      <BaseInputNumber
        :test-id="`DietDetailAssumptions__${index}__${meal.name}`"
        class="meal-energy-distrubution__input"
        :min="0"
        :max="100"
        :model-value="meal.energy_distribution"
        @update:model-value="
          dietStore.updateMealEnergyDistribution(index, $event)
        "
      />
      %
      <span class="meal-energy-distrubution__calories">
        {{ caloriesForDistribution(meal.energy_distribution) }}
        kcal
      </span>
    </div>
    <div class="meal-action">
      <IconButton
        v-if="canDelete"
        name="delete"
        type="destructive"
        @click="emit('delete', index, meal.name)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import BaseInput from '@/components/BaseInput.vue'
  import BaseInputNumber from '@/components/BaseInputNumber.vue'
  import BaseSelect from '@/components/BaseSelect.vue'
  import { IconButton } from '@/components/IconButton'
  import { mealTypes } from '@/const'
  import { useDietsStore } from '@/store/dietsStore'

  import type { DietData } from '@/types/Diet'

  defineProps<{
    caloriesForDistribution: (value: number) => number
    canDelete: boolean
    energyDistribution: boolean
    hourOptions: { text: string; value: string }[]
    index: number
    meal: DietData['meals'][number]
  }>()
  const emit = defineEmits<{ delete: [index: number, name: string] }>()
  const dietStore = useDietsStore()
</script>
